import { Sub } from '@radix-ui/react-context-menu'
import type { ComponentPropsWithoutRef, ReactNode } from 'react'

export interface ContextMenuSubProps extends ComponentPropsWithoutRef<
  typeof Sub
> {
  defaultOpen?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
  children: ReactNode
}

export const ContextMenuSub = Sub
